/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // fetch('/cart.js')
  // .then(res => res.json())
  // .then(cart => {
  //   const subscriptionVariantIds = [10240721748289];
  //   const updates = {};
  //   cart.items.forEach(item => {
  //     if (subscriptionVariantIds.includes(item.variant_id)) {
  //       updates[item.variant_id] = 0; // set qty to 0 = remove
  //     }
  //   });
  //   if (Object.keys(updates).length > 0) {
  //     return fetch('/cart/update.js', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ updates })
  //     });
  //   }
  // });


  // Product pages > Media > "Autoplay first video on page load"
  // The theme only loads a video once its slide is selected, so a featured video
  // sits as a poster until clicked. Load it after the page has finished loading
  // so the download doesn't compete with the rest of the page.
  function autoplayFeaturedVideos() {
    document.querySelectorAll('product-images[data-autoplay-featured-video]').forEach((gallery) => {
      const media = gallery.querySelector('.product__slide.media--active deferred-media:not([loaded])');
      if (media && typeof media.loadContent === 'function') media.loadContent(false);
    });
  }

  if (document.readyState === 'complete') {
    autoplayFeaturedVideos();
  } else {
    window.addEventListener('load', autoplayFeaturedVideos);
  }


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
